import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Slider from "react-slick"

// Config
import ModalConfig from "components/Stacker/config/ModalConfig"
import ModalGeneric from "components/Stacker/components/ModalGeneric/ModalGeneric"
import IPC from "components/Stacker/config/ImagePresetsConfig"

// Utils
import isMobile from "components/Stacker/utils/device-check"
// import { iOS } from 'lib/utils/helpers';

// Actions
import { destroyZoomModal } from "components/Stacker/actions/ZoomModalActions"

// Components
import ProductImage from "components/Stacker/components/ProductImage/ProductImage"
import SlickArrow from "components/Stacker/components/SlickArrow/SlickArrow"

import "./ProductZoom.scss"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"

function ProductZoom({ productImages, cropQuadrant }) {
  const slides = useSelector((state) => state.zoomModal)
  const dispatch = useDispatch()
  const [windowHeight, setHeight] = useState(window.innerHeight)

  useEffect(() => {
    const setModalHeight = () => {
      setHeight(window.innerHeight)
    }
    window.addEventListener("resize", setModalHeight)
    return () => {
      dispatch(destroyZoomModal())
      window.removeEventListener("resize", setModalHeight)
    }
  }, [])

  const settings = {
    accessibility: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
    speed: 500,
    // afterChange: index => {
    // 	dispatch(updateSlide(index));
    // },

    initialSlide: Number(slides.selectedIndex) || 0,
    nextArrow: <SlickArrow iconName="icon-carousel-arrow-right" />,
    prevArrow: <SlickArrow iconName="icon-carousel-arrow-left" />,
  }

  const isMobileScreen = isMobile()
  let zoomPreset = IPC.DEFUALT_PRESET
  if (cropQuadrant) {
    zoomPreset = `.jpg${cropQuadrant}`
  }

  const windowWidth = window.innerWidth
  return (
    <div className="ProductZoom">
      <ModalGeneric name={ModalConfig.MODAL_PDP_ZOOM}>
        <div
          style={{
            height: windowHeight,
            width: windowWidth,
          }}
        >
          <Slider {...settings}>
            {productImages.map((imagePath) => (
              <div key={imagePath}>
                <ProductImage
                  image={`${imagePath}${zoomPreset}`} // imagePath // `${AEM_ASSETS}/${imagePath}`
                  altImage={imagePath}
                  isMobileScreen={isMobileScreen}
                  isZoomed={slides.isZoomed}
                  scale={slides.scale}
                />
              </div>
            ))}
          </Slider>
        </div>
      </ModalGeneric>
    </div>
  )
}

ProductZoom.propTypes = {
  productImages: PropTypes.array,
  cropQuadrant: PropTypes.string,
  isZoomed: PropTypes.bool,
  height: PropTypes.number,
}

export default ProductZoom
